import { Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';

@Directive({ selector: '[mweClickOutside]' })
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);

  @Output() mweClickOutside = new EventEmitter<void>();

  @HostListener('document:click', ['$event.target'])
  public onClick(target): void {
    const clickedInside = this.elementRef.nativeElement.contains(target);

    if (!clickedInside) {
      this.mweClickOutside.emit();
    }
  }
}
